import { KV } from '../graphexp.service';

export class GremlinNode {
  label = '';
  properties: KV[] = [];
}
